import React from 'react';
import { userAppContext } from '../../Context/Context';
import ProfileData from './ProfileData';
import ProfileFavorites from './ProfileFavorites';
import ProfileApiKey from './ProfileApiKey';
import ProfileHashLinks from './ProfileHashLinks';
import { useLocation } from 'react-router-dom';
import APIContent from '../API/APIContent';
import ApiHashLinks from '../API/ApiHashiLinks';

const ProfileAreaContent = () => {
  const { user } = userAppContext();
  const userName = user['custom:name'];
  const location = useLocation();
  let hash = location.hash;
  hash = hash === '' ? '#profileData' : location.hash;

  const divContent = id => {
    const divClass = `tab-pane ${hash === '' || hash === '#' + id ? 'active show' : ''} `;
    return divClass;
  };

  const profileDataClass = divContent('profileData');
  const profileFavoritesClass = divContent('favorites');
  const apiKeyClass = divContent('apiKey');

  return (
    <React.Fragment>
      <div className="container2">
        <span
          style={{
            lineHeight: 1,
          }}
        >
          <h1 className="pt-4">Welcome{userName && `, ${userName}`}</h1>
        </span>
        <div className="col-12 col-md-3 order-0 order-md-0 mb-4 mb-md-0"></div>
        <div className="row txt-contenido border-top border-bottom pt-4 pb-4">
          <div className="col-12 col-md-3 order-0 order-md-0 mb-4 mb-md-0">
            <ProfileHashLinks hash={hash} />
            <ApiHashLinks hash={hash} />
          </div>

          <div className="col-12 col-md-8 order-1 order-md-1">
            <div className="tab-content ml-5" id="dbInfoTabbedPane">
              <ProfileData profileDataClass={profileDataClass} />
              <ProfileFavorites favoritesClass={profileFavoritesClass} />
              <ProfileApiKey apiKeyClass={apiKeyClass} />
              <APIContent />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProfileAreaContent;
